const EXCHANGE_PERFORMANCE_PATH = 'exchange-in-out'
const EXCHANGE_MEMBERS_STAT_PATH = 'members-by-exchange'
const TOP_EXCHANGE_PARTNERS_PATH = 'top-exchange-partners'
const TOTAL_ACTIVE_MEMBERS_PATH = 'total-active-members'

export {
  EXCHANGE_PERFORMANCE_PATH,
  EXCHANGE_MEMBERS_STAT_PATH,
  TOP_EXCHANGE_PARTNERS_PATH,
  TOTAL_ACTIVE_MEMBERS_PATH
}
